module.exports = __webpack_public_path__ + "images/47ad908bd5e62fe4795f02206aea1b43.png";